import React, { Component } from 'react';
import { connect } from 'react-redux';
import { EyeOutlined, ReloadOutlined, RollbackOutlined } from '@ant-design/icons';
import { Table, Modal, Tag, DatePicker, Button } from 'antd';
import PageTitle from '@/components/PageTitle';
import TableActionBar from '@/components/TableActionBar';
import _, { } from 'lodash';
import qs from 'qs';
import { Form } from '@ant-design/compatible';
import { checkPermission } from '@/utils/permission';
import { cleanObject, isValidDate } from '@/utils/helpers';
import BaseSelect from '@/components/Elements/BaseSelect';
import moment from 'moment';
import AuditLogDetail from '@/routes/audit-logs/AuditLogDetail';
import { searchAuditLogs, viewAuditLogDetail, rollbackAuditLog, getAuditLogModels } from '@/redux/actions/auditLogActions';
import { getActionColor } from '@/utils/helpers';

const { confirm } = Modal;
const { RangePicker } = DatePicker;

const routes = [
    {
        path: '/',
        breadcrumbName: 'Trang chủ',
    },
    {
        path: '/audit-logs',
        breadcrumbName: 'Audit logs',
    },
]

class AuditLogSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            selectedRowKeys: [],
            currentData: null,
            isOpenDetail: false
        }

        this.query = qs.parse(this.props.location.search.slice(1));
    }

    componentDidMount() {
        this.loadData(this.query);
        this.props.getAuditLogModels();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.location.search !== this.props.location.search.slice()) {
            var query = qs.parse(nextProps.location.search.slice(1));
            this.setState({ isLoading: true });
            this.loadData(query);
        }
    }

    onChangeFilter(name, value) {
        var query = qs.parse(this.props.location.search.slice(1));
        query = {
            ...query,
            [name]: value
        }
        if (name === 'created_at') {
            if (value && value.length > 0) {
                query.from = moment(value[0]).format('YYYY-MM-DD');
                query.to = moment(value[1]).format('YYYY-MM-DD');
            } else {
                delete query.from;
                delete query.to;
            }
        }
        delete query.created_at;
        query = cleanObject(query);

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query)
        });
    }

    onChangeTable(pagination, sorter) {
        var query = qs.parse(this.props.location.search.slice(1));
        if (!_.isEmpty(pagination)) {
            query = {
                ...query,
                page: pagination.current,
                per_page: pagination.pageSize,
            }
        }
        if (!_.isEmpty(sorter)) {
            if (sorter.order) {
                query = {
                    ...query,
                    sort_field: sorter.field,
                    sort_type: sorter.order === 'ascend' ? 'ASC' : 'DESC'
                }
            } else {
                delete query.sort_field;
                delete query.sort_type;
            }
        }

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query),
        });
    }

    onSelectChange = selectedRowKeys => {
        this.setState({ selectedRowKeys });
    };

    onRemove() {
        this.props.remove(this.state.selectedRowKeys).then(() => {
            this.setState({ selectedRowKeys: [] });
            setTimeout(() => {
                Modal.destroyAll();
            }, 800);
            this.loadData(this.query);
        })
    }
    openAlert(id) {
        confirm({
            title: 'Cảnh báo',
            content: 'Bạn chắc chắn muốn xoá khách hàng này?',
            okText: 'OK',
            cancelText: 'Huỷ',
            onOk: () => this.props.remove([id]).then(() => {
                setTimeout(() => {
                    Modal.destroyAll();
                }, 800);
                this.loadData(this.query);
            }),
            onCancel() { },
        })
    }

    toggleOpenDetail(isOpenDetail, data = null) {
        this.setState({ isOpenDetail: isOpenDetail, currentData: data });
    }

    // Chưa lấy được dữ liệu nây, mai làm tiếp
    onDetail(id) {
        this.props.viewAuditLogDetail(id).then(res => {
            this.toggleOpenDetail(true, res);
        })
    }

    loadData(query) {
        this.setState({ isLoading: true });
        this.props.searchAuditLogs(query).then(() => {
            this.setState({ isLoading: false });
        })
    }

    onCancel() {
        this.props.form.resetFields();
        this.setState({
            isOpenDetail: false
        })
    }

    handleRollback = (logId) => {
        const { rollbackAuditLog } = this.props;

        Modal.confirm({
            title: 'Xác nhận rollback?',
            content: 'Bạn có chắc muốn rollback bản ghi này về trạng thái cũ không?',
            okText: 'Rollback',
            okType: 'danger',
            cancelText: 'Huỷ',
            onOk: async () => {
                try {
                    await rollbackAuditLog(logId);
                    this.loadData(this.query); // Tải lại dữ liệu
                } catch (err) {
                    console.log(err);
                }
            }
        });
    }

    render() {
        var { logs, pagination, users, model_options } = this.props;
        var { isLoading, selectedRowKeys, isOpenDetail, currentData } = this.state;
        var query = qs.parse(this.props.location.search.slice(1));

        const columns = [
            { title: 'ID', dataIndex: 'id', width: 50 },
            {
                title: 'Chi tiết',
                width: 80,
                render: (_, record) => (
                    <Button
                        className='btn-view'
                        size="small"
                        type="dashed"
                        icon={<EyeOutlined />}
                        onClick={() => this.onDetail(record.id)}
                        disabled={!checkPermission('audit_logs', 'detail')}
                    >
                        Xem
                    </Button>
                )
            },
            { title: 'Model', dataIndex: 'model' },
            {
                title: 'Hành động',
                dataIndex: 'action',
                render: (text) => <Tag color={getActionColor(text)}>{text.toUpperCase()}</Tag>
            },
            {
                title: 'Người thực hiện',
                dataIndex: 'user_id',
                render: (text, record) =>
                    <>{record.user ? record.user.full_name : ''}</>
            },
            {
                title: 'Thời gian',
                dataIndex: 'created_at',
                render: (text) => <>{isValidDate(text)}</>
            }
        ];

        if (checkPermission('audit_logs', 'rollback')) {
            columns.push({
                title: 'Rollback',
                width: 80,
                render: (_, record) =>
                    (record.action === 'update' || record.action === 'delete') ? (
                        <Button
                            onClick={() => this.handleRollback(record.id)}
                            size="small"
                            type="dashed"
                            danger
                            icon={<RollbackOutlined />}
                        >
                            Rollback
                        </Button>
                    ) : null,
            });
        }

        return (
            <div>
                <PageTitle routes={routes} title="Audit logs" />
                <div>
                    <TableActionBar
                        isShowAddButton={false}
                        isShowDeleteButton={false}
                        disabled={!selectedRowKeys.length ? true : false}
                        showFilter={true}
                        onSearch={(value) => this.onChangeFilter('keyword', value)}
                        activeFilter={
                            query.from ||
                            query.to ||
                            query.model ||
                            query.action ||
                            query.user_id
                        }
                        filters={
                            [
                                <RangePicker
                                    format="DD/MM/YYYY"
                                    placeholder={['Ngày', 'Đến ngày']}
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('created_at', value)}
                                    defaultValue={[query.from ? moment(query.from, 'YYYY-MM-DD') : null, query.to ? moment(query.to, 'YYYY-MM-DD') : null]}
                                />,
                                <BaseSelect
                                    options={users || []}
                                    optionValue="user_id"
                                    optionLabel="display_name"
                                    showSearch
                                    placeholder="Người thực hiện"
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('user_id', value)}
                                    defaultValue={query.user_id ? parseInt(query.user_id) : null}
                                />
                            ]
                        }
                    >
                        <BaseSelect
                            options={model_options ?? []}
                            optionValue="value"
                            optionLabel="label"
                            placeholder="Model"
                            className="table-button"
                            showSearch
                            style={{ width: '200px' }}
                            onChange={(value) => this.onChangeFilter('model', value)}
                            defaultValue={query.model ? query.model : null}
                        />
                        <BaseSelect
                            options={[
                                { label: 'Create', value: 'create' },
                                { label: 'Update', value: 'update' },
                                { label: 'Delete', value: 'delete' },
                                { label: 'Rollback', value: 'rollback' }
                            ]}
                            showSearch
                            placeholder="Hành động"
                            onChange={(value) => this.onChangeFilter('action', value)}
                            className="table-button"
                            style={{ width: '200px' }}
                            defaultValue={query.action ? query.action : null}
                        />
                        <Button className="table-button" icon={<ReloadOutlined />} loading={isLoading} onClick={() => this.loadData(query)}>Refresh</Button>
                    </TableActionBar>
                </div>

                <Table
                    rowKey="id"
                    size="small"
                    tableLayout='auto'
                    dataSource={logs ?? []}
                    columns={columns}
                    loading={isLoading}
                    pagination={{
                        pageSize: pagination.perPage,
                        current: pagination.currentPage,
                        total: pagination.total,
                        showTotal: total => `Tổng ${total} bản ghi`,
                        defaultPageSize: 30, showSizeChanger: true, pageSizeOptions: ['10', '20', '30', '40', '50', '100', '200']
                    }}
                    onChange={(pagination, filters, sorter) => this.onChangeTable(pagination, sorter)}
                    scroll={{
                        x: 'max-content'
                    }}
                />

                <AuditLogDetail
                    visible={isOpenDetail}
                    currentItem={currentData}
                    reloadData={() => this.loadData}
                    onCancel={() => this.toggleOpenDetail(false)}
                />
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        logs: state.auditLogReducer.audit_logs.logs,
        pagination: state.auditLogReducer.audit_logs.pagination,
        model_options: state.auditLogReducer.model_options,
        users: state.config.users,
        config: state.config
    }
}

function mapDispatchToProps(dispatch) {
    return {
        searchAuditLogs: (filters) => dispatch(searchAuditLogs(filters)),
        viewAuditLogDetail: (id) => dispatch(viewAuditLogDetail(id)),
        rollbackAuditLog: (logId) => dispatch(rollbackAuditLog(logId)),
        getAuditLogModels: () => dispatch(getAuditLogModels()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'AuditLogSearch' })(AuditLogSearch));

